<template>
    <b-modal
        ref="globalAlert"
        centered
        hide-header-close
        :title-html="globalAlertTitle"
        :title-class="globalAlertTitleClass"
        @hide="clearGlobalAlert()"
    >
        {{ globalAlertContent }}

        <div v-if="!disableNotification && showErrorNotificationCheckbox" class="mt-4">
            <b-form-checkbox v-model="notifyError">Notificar a Hostoo sobre o problema ocorrido.</b-form-checkbox>
            <textarea
                v-show="notifyError"
                class="form-control mt-4"
                rows="3"
                placeholder="Se desejar, informe mais detalhes sobre o problema..."
                v-model="errorNotificationDetails"></textarea>
        </div>

        <template slot="modal-footer" slot-scope="{ hide }">
            <button type="button" class="btn btn-secondary btn-action" @click="hide">Fechar</button>
            <button v-if="!disableNotification" v-show="notifyError" type="button" class="btn btn-primary btn-action" @click="sendErrorNotification">Enviar</button>
        </template>
    </b-modal>
</template>

<script>
    import { mapActions, mapState } from "vuex";

    export default {
        props: {
            disableNotification: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                globalAlertShow: false,
                notifyError: false,
                errorNotificationDetails: "",
            }
        },
        computed: {
            ...mapState({
                globalAlertType:    state => state.alert.type,
                globalAlertMessage: state => state.alert.message,
                errorResponse:      state => state.alert.response,
                rawError:           state => state.alert.rawError,
            }),

            globalAlertSubtype: function()
            {
                if (this.globalAlertType === "danger")
                {
                    if (this.errorResponse && this.errorResponse.status && this.errorResponse.status >= 500) {
                        return "error";
                    }
                    else {
                        return "warning";
                    }
                }

                return "info";
            },

            globalAlertTitle: function()
            {
                switch (this.globalAlertSubtype) {
                    case "error":   return '<i class="fas fa-minus-circle fa-fw"></i> Erro';
                    case "warning": return '<i class="fas fa-exclamation-circle fa-fw"></i> Alerta';
                    case "info":
                    default:        return '<i class="fas fa-info-circle fa-fw"></i> Notificação';
                }
            },

            globalAlertTitleClass: function()
            {
                switch (this.globalAlertSubtype) {
                    case "error": return "text-danger";
                    default:      return "text-primary";
                }
            },

            showErrorNotificationCheckbox: function()
            {
                return (
                    this.globalAlertSubtype === "error" &&
                    this.errorResponse.status !== 502 &&
                    this.errorResponse.status !== 503 &&
                    this.errorResponse.status !== 524
                );
            },

            globalAlertContent: function()
            {
                if (this.globalAlertSubtype === "error" && (this.errorResponse.status === 522 || this.errorResponse.status === 524)) {
                    return 'O servidor demorou muito tempo para responder. Por favor, atualize sua página e tente novamente. Se o erro persistir, entre em contato com nosso Suporte.';
                }
                else {
                    return this.globalAlertMessage;
                }
            }
        },
        methods: {
            ...mapActions({
                clearGlobalAlert: 'alert/clear',
            }),

            sendErrorNotification()
            {
                const currentPage  = window.location.href || '';
                const errorConfig  = this.errorResponse && this.errorResponse.config ? this.errorResponse.config : {};
                const errorData    = this.errorResponse && this.errorResponse.data ? this.errorResponse.data : {};
                const errorMessage = errorData.message || this.globalAlertMessage || '';

                let message = `Página: ${currentPage}\nMensagem: ${errorMessage}`;

                if (this.errorNotificationDetails) {
                    message += `\n\n${this.errorNotificationDetails}`;
                }

                const apiUrl    = errorConfig.url || '';
                const apiMethod = errorConfig.method ? errorConfig.method.toUpperCase() : '';
                const apiStatus = this.errorResponse && this.errorResponse.status ? this.errorResponse.status : '';

                let note = '';

                if (apiUrl) {
                    note += `API: ${apiMethod} ${apiUrl}\nStatus: ${apiStatus}\n`;
                }

                if (this.rawError)
                {
                    if (this.rawError.message) {
                        note += `Mensagem: ${this.rawError.message}\n`;
                    }

                    if (this.rawError.stack) {
                        note += `Stack: ${this.rawError.stack}`;
                    }
                }

                let postData = {
                    subject: -1,
                    otherSubject: 'Notificação de erro',
                    department: 1,
                    message: message,
                    note: note,
                };

                if (this.hosting && this.hosting.domain) {
                    postData['service'] = this.hosting.domain;
                }

                this.$api.post('/ticket', postData).catch(() => {/* ignore error */});
                this.$refs.globalAlert.hide();
            },
        },
        watch: {
            globalAlertMessage: function (val) {
                if (!!val) {
                    this.notifyError = false;
                    this.$refs.globalAlert.show();
                }
                else {
                    this.$refs.globalAlert.hide();
                }
            }
        }
    }
</script>



<style scoped lang="stylus">

</style>